// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-10T15:20:15+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190767
//    Project:        298
//    Environment:    7805 - release/24-11-2025/r2
//    MD5:            ae40c7d734fdce5f877ce306c4a26799
//    Signature:      eyJpdiI6Im5Pcmg4UnlvdEgrTkYxRnRYYVNBdXc9PSIsInZhbHVlIjoiVHlVTlZKMEV3SjEyaFwvZlZoTmt2WnJGNHFTM2JndVU5Y1diRG9INDBxa0hMZzhCT1p3TXFSa2JiYzd2U1NjemRuRHM1eHdBc2FpZ24yNmdrNGJyRkxtV2RoZjl6KzFaZFhwQVBQck9FbXhMZ3gzSUszdE5YcTNPWDhoQUc3YU00NW1tNEtxb3RQNEkrUmlUTDh6RWswNXlnTXVFOGxsZFNNeHhmWWN0b1NQek1cL0dGYWpCck1YZ0R2a0RzNXhzazJqZ2x1RW1WWlphVkVCRjM1d29xcFJrR0sxUmx4c2RuV3pIbVdDaHBaVXBHN2QxWldPeGZqbStWc0N5VmZ6Y29JcFIzMjRIRHFUaUJYaHJxQnZJZnhrT1ZLN2Rpa3NsWVJSdThRUzBGYWxmM00yWlBWZXZDdzhoZzVuTWhIcGIwMnp5cXM0ekNWYTBuaEN5bXU0dkY1RWF0TlFOaityNWRJOVFKN2pYZU9UdU10UlI2cnBiVDBna2duMXNIUGFsWVgwTERVUVBhekwwMFJvR2h5VU8zWmxnPT0iLCJtYWMiOiI3MDNjNmU3ZDRjMGRiYjdiNDljYTY4MzQ3NjFmNmViMjBhZjk5ZWU0OTBlOTMzYmIzYmRmMDM4NDlkY2QwMGM5In0=

// Used for the screen reader to access the submenu

let currentlyOpenLink = null;

document.querySelectorAll('.navigation-menu__nav-item-link').forEach(link => {
    const submenuId = link.getAttribute('aria-controls');
    const submenu = document.getElementById(submenuId);

    // Close previously open submenu on focus
    link.addEventListener('focus', () => {
        if (currentlyOpenLink && currentlyOpenLink !== link) {
            const prevSubmenuId = currentlyOpenLink.getAttribute('aria-controls');
            const prevSubmenu = document.getElementById(prevSubmenuId);
            if (prevSubmenu) {
                currentlyOpenLink.setAttribute('aria-expanded', 'false');
                prevSubmenu.hidden = true;
            }
            currentlyOpenLink = null;
        }
    });

    link.addEventListener('keydown', e => {
        if (!submenu) return;

        // Add Escape key support to submenu items
        if (submenu) {
            submenu.querySelectorAll('.megamenu__navigation-item').forEach(item => {
                item.addEventListener('keydown', e => {
                    if (e.key === 'Escape') {
                        link.setAttribute('aria-expanded', 'false');
                        submenu.hidden = true;
                        link.focus();
                        currentlyOpenLink = null;
                    }
                });
            });
        }

        // Toggle submenu with Enter or Space
        if ((e.key === 'Enter' || e.key === ' ') && submenu) {
            e.preventDefault();

            const isExpanded = link.getAttribute('aria-expanded') === 'true';

            // Close any other open submenu
            if (currentlyOpenLink && currentlyOpenLink !== link) {
                const prevSubmenuId = currentlyOpenLink.getAttribute('aria-controls');
                const prevSubmenu = document.getElementById(prevSubmenuId);
                if (prevSubmenu) {
                    currentlyOpenLink.setAttribute('aria-expanded', 'false');
                    prevSubmenu.hidden = true;
                }
            }

            // Toggle this submenu
            link.setAttribute('aria-expanded', String(!isExpanded));
            submenu.hidden = isExpanded;

            // Focus first menu item if opening
            if (!isExpanded) {
                const firstItem = submenu.querySelector('[role="menuitem"]');
                if (firstItem) firstItem.focus();
                currentlyOpenLink = link;
            } else {
                currentlyOpenLink = null;
            }
        }

        // Close submenu with Escape
        if (e.key === 'Escape' && link.getAttribute('aria-expanded') === 'true') {
            link.setAttribute('aria-expanded', 'false');
            submenu.hidden = true;
            link.focus();
            currentlyOpenLink = null;
        }
    });
});
